<template>
  <div id="app">
    <DrawingBoard />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { getSessionId } from './utils/sessionService';
import DrawingBoard from './components/DrawingBoard.vue';

onMounted(async () => {
  await getSessionId();
});
</script>
<!-- <script>
import WebSocketChat from './components/WebSocketChat.vue';

export default {
  components: {
    WebSocketChat
  }
};
</script> -->